import React, { PureComponent } from 'react';
import { Keyboard, KeyboardAvoidingView, Platform, StyleSheet } from 'react-native';
import SafeView from './SafeView';

export default class KeyboardHandle extends PureComponent {
  state = {};

  componentDidMount() {
    this.showSub = Keyboard.addListener('keyboardDidShow', () => this.setState({ keyboardVisible: true }));
    this.hideSub = Keyboard.addListener('keyboardDidHide', () => this.setState({ keyboardVisible: false }));
  }

  componentWillUnmount() {
    this.showSub?.remove();
    this.hideSub?.remove();
  }

  render() {
    // keyboardVerticalOffset phụ thuộc vào padding top của root view #https://github.com/facebook/react-native/issues/13393
    const isiOS = Platform.OS === 'ios';
    const { keyboardVisible } = this.state;
    return (
      <KeyboardAvoidingView
        keyboardVerticalOffset={keyboardVisible || isiOS ? SafeView.getPaddingTop() : 0}
        behavior={isiOS ? 'padding' : 'height'}
        {...this.props}
        style={StyleSheet.flatten([{ flex: 1 }, this.props.style])}>
        {this.props.children}
      </KeyboardAvoidingView>
    );
  }
}
